import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../Icon'
import { Status, STATUS_SIZE_16 } from '../../../../Status'
import Text from '../../../../Text'
import { RentalPortalTimelineMarker } from '../../../RentalPortalTimelineMarker'

import * as styles from './ApplicantProfileWidgetStageScreeningRow.module.css'

import InformationIcon from '../../../../../icons/info.svg'

function ApplicantProfileWidgetStageScreeningRow({
  hint,
  isDone,
  isLast,
  isLineDone,
  labelKey,
  statusText,
  statusTextColor,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.ApplicantProfileWidgetStageScreeningRow}>
      <RentalPortalTimelineMarker
        isDone={isDone}
        isLast={isLast}
        isLineDone={isLineDone}
      />
      <div
        className={classNames(styles.content, {
          [styles.contentLast]: isLast,
        })}
      >
        <Text className={styles.label}>{t(labelKey)}</Text>
        {statusText ? (
          <Status
            height={STATUS_SIZE_16}
            text={statusText}
            textColor={statusTextColor}
          />
        ) : null}
        {hint ? (
          <IconWithTooltip
            Icon={InformationIcon}
            size={ICON_HEIGHT_16}
            svgSize={ICON_HEIGHT_16}
            tooltip={hint}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ApplicantProfileWidgetStageScreeningRow
